import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const IMAGES = [
  'https://images.unsplash.com/photo-1485827404703-89b55fcc595e?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1502744688674-c619d1586c9e?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1534447677768-be436bb09401?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1473773508845-188df298d2d1?auto=format&fit=crop&w=800&q=80',
  'https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=800&q=80',
];

const GRADIENTS = [
  'from-primary/40 to-pink/30',
  'from-accent/30 to-primary/40',
  'from-pink/40 to-primary-dark/40',
  'from-primary-light/40 to-accent/30',
  'from-pink/30 to-accent/40',
  'from-primary/40 to-pink/40',
];

const Gallery = () => {
  const { t } = useLanguage();

  return (
    <section id="gallery" className="py-24 relative bg-dark">
      <div className="absolute inset-0 opacity-40 pointer-events-none bg-[radial-gradient(ellipse_at_30%_0%,rgba(147,51,234,0.12),transparent_50%)]" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white font-heading leading-tight">
            {t.gallery.title}
          </h2>
          <p className="mt-4 text-lg text-slate-400 leading-relaxed">{t.gallery.subtitle}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {t.gallery.items.map((item, index) => (
            <article
              key={item.title}
              className="group bg-card-dark border border-border-dark rounded-2xl overflow-hidden hover:border-primary/35 hover:shadow-glow transition-all duration-300 hover:-translate-y-1"
            >
              <div className={`relative aspect-[4/3] bg-gradient-to-br ${GRADIENTS[index % GRADIENTS.length]}`}>
                <img
                  src={IMAGES[index % IMAGES.length]}
                  alt={item.prompt}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                  width={800}
                  height={600}
                  onError={(e) => {
                    e.currentTarget.style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/80 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 bg-dark/70 backdrop-blur border border-white/10 text-primary-light text-xs font-semibold px-3 py-1 rounded-full">
                  {t.gallery.styleLabel}: {item.style}
                </span>
              </div>

              <div className="p-6">
                <h3 className="text-lg font-bold text-white font-heading">{item.title}</h3>
                <p className="mt-2 text-slate-400 text-sm italic leading-relaxed">“{item.prompt}”</p>
                <div className="mt-5 flex items-center gap-3 border-t border-border-dark pt-4">
                  <span className="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-pink flex items-center justify-center text-white text-sm font-bold">
                    {item.author.charAt(0)}
                  </span>
                  <div className="leading-tight">
                    <p className="text-white text-sm font-semibold">{item.author}</p>
                    <p className="text-slate-500 text-xs">{item.role}</p>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
